import { apiGuestClient } from './apiGuestClient';

export const TINH_HUYEN_XA_API_END_POINT = "tinh";

export const tinhHuyenXaApi = {
    // Lấy danh sách tỉnh
    selectTinh: () => apiGuestClient.get(`${TINH_HUYEN_XA_API_END_POINT}`),

    // Lấy danh sách huyện theo tỉnh
    selectHuyenByTinh: (id: number) => 
    apiGuestClient.get(`${TINH_HUYEN_XA_API_END_POINT}/${id}/huyen`),

    // Lấy danh sách xã theo huyện
    selectXaByHuyen: (id: number) => 
    apiGuestClient.get(`huyen/${id}/xa`),

    selectQuocTich: () => apiGuestClient.get(`quoc-tich`),
};
